var _rect, _path, _path2, _rect2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEmptyFilteredTable = function SvgEmptyFilteredTable(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 69,
    viewBox: "0 0 100 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 35.5664,
    width: 3,
    height: 28.7174,
    transform: "rotate(-25 2.5 35.5664)",
    fill: "#E7E8E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 60C10.5 58.3431 11.8431 57 13.5 57H15.5C17.1569 57 18.5 58.3431 18.5 60V60H10.5V60Z",
    fill: "#818CF8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 62C5 60.8954 5.89543 60 7 60H23C24.1046 60 25 60.8954 25 62V63H5V62Z",
    fill: "#6366F1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25.1777,
    y: 9,
    width: 3,
    height: 31.0043,
    transform: "rotate(45 25.1777 9)",
    fill: "#E7E8E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 64.3411L32.5 27.5L49 14L99.5 64.3411H40Z",
    fill: "#EFF0F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5 69C85.7924 69 99 66.7614 99 64C99 61.2386 85.7924 59 69.5 59C53.2076 59 40 61.2386 40 64C40 66.7614 53.2076 69 69.5 69Z",
    fill: "#DDDDE1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49 14.0068L32.5747 27.457C27.4154 21.1467 27.6706 15.0517 28.443 12.793L24.5131 8.14028C23.2029 6.01662 24.8154 4.70194 24.8154 4.70194L28.443 1.76918C28.443 1.76918 30.1559 0.757837 31.7685 2.37596L35.3962 6.92774C42.4903 6.60412 47.4213 11.5123 49 14.0068Z",
    fill: "#4F46E5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 33C1.5 34.1046 2.39543 35 3.5 35C4.60457 35 5.5 34.1046 5.5 33C5.5 31.8954 4.60457 31 3.5 31C2.39543 31 1.5 31.8954 1.5 33Z",
    fill: "white",
    stroke: "#E7E8E9",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 17C17.5 18.1046 18.3954 19 19.5 19C20.6046 19 21.5 18.1046 21.5 17C21.5 15.8954 20.6046 15 19.5 15C18.3954 15 17.5 15.8954 17.5 17Z",
    fill: "white",
    stroke: "#E7E8E9",
    strokeWidth: 2
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEmptyFilteredTable);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "empty-filtered-table.5ef95237db117ea83a59c906416794cf.svg";